import { render } from "./Favorites.vue?vue&type=template&id=dbdb2774&scoped=true&ts=true"
import script from "./Favorites.vue?vue&type=script&lang=ts"
export * from "./Favorites.vue?vue&type=script&lang=ts"

import "./Favorites.vue?vue&type=style&index=0&id=dbdb2774&lang=scss&scoped=true"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbdb2774"]])

export default __exports__